import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Product
import ProductReducer from "./product/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import CategoryReducer from "./category/reducer";
import BrandReducer from "./brand/reducer";
import ColorsReducer from "./color/reducer";
import AttributeReducer from "./attributes/reducer";
import ModelReducer from "./model/reducer";
import DiscountReducer from "./discount/reducer";
import NewsReducer from "./pages/news/reducer";
import SubMenuReducer from "./submenu/reducer";
import BlockReducer from "./block/reducer";
import HomeLayoutReducer from "./homeLayout/reducer";
import BannerSliderReducer from "./pages/bannerSlider/reducer";
import BadgeReducer from "./badge/reducer";

const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Login: LoginReducer,
    Category: CategoryReducer,
    Brand: BrandReducer,
    Colors: ColorsReducer,
    Attribute: AttributeReducer,
    Product: ProductReducer,
    Model: ModelReducer,
    Discount: DiscountReducer,
    News: NewsReducer,
    SubMenu: SubMenuReducer,
    Block: BlockReducer,
    HomeLayout: HomeLayoutReducer,
    BannerSlider: BannerSliderReducer,
    Badge: BadgeReducer,
});

export default rootReducer;

